<template>
  <div class="modal-card m-0" style="width: auto">
    <header class="modal-card-head" v-show="!showReset">
      <h1 class="modal-card-title has-text-centered">{{ $t('general.login') }}</h1>
    </header>
    <section class="modal-card-body" v-if="!forgotten">
      <ValidationObserver v-slot="{invalid}">
        <form>
          <b-notification type="is-danger" has-icon v-if="error" :closable="false" role="alert" aria-live="assertive">
            <strong>{{ $t('errors.invalid-user-data') }}</strong>
            <p class="is-size-7">{{ $t('errors.check-input') }}</p> </b-notification
          ><ValidationProvider name="E-Mail" :rules="{required: true}" v-slot="{errors}">
            <b-field :label="$t('general.email')" label-for="login-email" class="mb-4">
              <b-input id="login-email" aria-describedby="error-email" v-model="userName" type="email"></b-input>
              <p id="error-email" class="help is-danger" role="alert" aria-live="assertive" v-for="error in errors" :key="error">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <ValidationProvider name="Passwort" :rules="{required: true}" v-slot="{errors}">
            <b-field :label="$t('general.password')" label-for="login-password">
              <b-input id="login-password" aria-describedby="error-password" type="password" v-model="password" password-reveal @keyup.enter.native="login"></b-input>
              <p id="error-password" class="help is-danger" role="alert" aria-live="assertive" v-for="error in errors" :key="error">{{ error }}</p>
            </b-field>
          </ValidationProvider>
          <b-button type="is-primary" size="is-medium" :disabled="invalid" class="is-fullwidth mt-4" @click="login">{{ $t('general.login') }}</b-button>
        </form>
      </ValidationObserver>
    </section>
    <section class="modal-card-body" v-if="forgotten">
      <b-notification type="is-success" has-icon v-if="resetSuccess" :closable="false" role="alert" aria-live="polite">
        {{ $t('account.recovery-mail-has-been-sent') }}
      </b-notification>
      <b-notification type="is-danger" has-icon v-if="errorreset" :closable="false" role="alert" aria-live="assertive">
        <strong>{{ $t('errors.invalid-email-address') }}</strong>
        <p class="is-size-7">{{ $t('errors.unknown-email') }}</p>
      </b-notification>
      <ValidationObserver v-slot="{invalid}">
        <ValidationProvider name="E-Mail" :rules="{required: true, email: true}" v-slot="{errors}">
          <b-field :label="$t('general.email')" label-for="reset-email">
            <b-input id="reset-email" aria-describedby="error-reset-email" type="email" v-model="email"></b-input>
            <p id="error-reset-email" class="help is-danger" role="alert" aria-live="assertive" v-for="error in errors" :key="error">{{ error }}</p>
          </b-field>
        </ValidationProvider>
        <b-button type="is-primary" size="is-medium" :disabled="invalid" @click="reset" class="is-fullwidth mt-4">{{ $t('account.password-reset') }}</b-button>
      </ValidationObserver>
    </section>
    <footer class="modal-card-foot" v-show="!showReset">
      <small v-if="!forgotten"
        ><button
          type="is-text"
          v-on:click="
            forgotten = true
            focusElement('reset-email')
          "
          class="button is-text has-text-black-ter"
          @keydown.enter="focusElement('reset-email')"
        >
          {{ $t('account.password-forgotten') }}
        </button></small
      >
      <small v-if="forgotten"
        ><button
          type="is-text"
          v-on:click="
            forgotten = false
            focusElement('login-email')
          "
          class="button is-text has-text-black-ter"
          @keydown.enter="focusElement('login-email')"
        >
          {{ $t('account.back-to-login') }}
        </button></small
      >
    </footer>
  </div>
</template>

<script>
import focusMixin from '@/mixins/focusMixin'

export default {
  name: 'LoginWindow',
  props: {
    showReset: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userName: '',
      password: '',
      error: false,
      forgotten: false,
      errorreset: false,
      resetSuccess: false,
      email: '',
    }
  },
  mixins: [focusMixin],
  mounted() {
    if (this.showReset) {
      this.forgotten = true
    }
  },
  methods: {
    async login() {
      let res = await this.$store.dispatch('login', {usr: this.userName, pwd: this.password})
      this.error = !res.success
    },
    async reset() {
      let res = await this.$store.dispatch('passwordForgotten', {email: this.email})
      this.errorreset = !res.success
      this.resetSuccess = res.success
    },
  },
}
</script>

<style lang="scss" scoped>
// .login {
//   height: 100vh;
//   margin-top: -5rem;
// }

.modal-card-foot {
  justify-content: center;
}
</style>
